import { useEffect, useState } from "react"
import { useToken } from "contexts/authorization/hooks/use-token"
import { useConfigurationContext } from "contexts/configuration/context"
import { useApiInfo } from "contexts/configuration/hooks/use-api-info"
import useOpus from "contexts/opus/hooks/use-opus"
import { addOpusCompanyID } from "utils/opus-iframe"
interface IGetMTAPolicyURL {
  opusFinalUrl: string
}

const useGetMTAPolicyUrl = (
  productRef: string,
  productCover: string,
  id: string,
  userId: string,
  questionSetReferenceID?: string
): IGetMTAPolicyURL => {
  const [opusFinalUrl, setOpusFinalUrl] = useState<string>("")
  const { apiInfo } = useApiInfo()
  const { userToken } = useToken()
  const { activeBranchID } = useOpus()
  const configContext = useConfigurationContext()

  useEffect(() => {
    if (
      configContext &&
      configContext.opus.baseOpusUrl &&
      apiInfo &&
      productRef &&
      productCover &&
      id &&
      userId &&
      userToken
    ) {
      setOpusFinalUrl(
        addOpusCompanyID(
          `${configContext.opus.baseOpusUrl}/quote/adjust?` +
            `productReference=${productRef}&` +
            `productCoverReference=${productCover}&` +
            `tenantReference=${apiInfo?.orgInfo.tenantReferenceId}&` +
            `tenantOrgReference=${apiInfo?.orgInfo.referenceId}&` +
            `policyId=${id}&` +
            `userId=${userId}&` +
            `token=${userToken}&` +
            `questionSetReferenceID=${questionSetReferenceID ?? ""}`,
          activeBranchID
        )
      )
    }
  }, [
    configContext,
    apiInfo,
    productRef,
    productCover,
    userId,
    id,
    userToken,
    questionSetReferenceID,
    activeBranchID
  ])

  return {
    opusFinalUrl
  }
}

export default useGetMTAPolicyUrl
